import { createSelector } from 'reselect'

const interactiveVideoData = state => state.interactiveVideoCreation

const getBreakpointActivityDataSelector = breakpointActivityUid => createSelector(
	[ interactiveVideoData ],
	interactiveVideoData => {
		let breakpointActivityData
		const breakpoints = interactiveVideoData.media.breakpoints

		for (let i = 0; i < breakpoints.length; i++) {
			breakpointActivityData = breakpoints[i].activities.find(
				activity => activity.uid === breakpointActivityUid
			)
			if (!!breakpointActivityData) {
				break
			}
		}

		return breakpointActivityData
	}
)

export default getBreakpointActivityDataSelector
